import { useTranslation } from "react-i18next";
import { PageBody, PageHeader, PageLayout } from "../../components";
import { useCallback, useEffect, useState } from "react";
import { IImageGenerationDataModel } from "../../types/imageGeneration";
import { loadImageGenerationResults } from "../../services/imageGeneration/loadImageGenerationResults";
import EmptyState from "../../components/EmptyState/EmptyState";
import ImageGenerationResultEntry from "../../features/ImageGenerationResultEntry/ImageGenerationResultEntry";
import { ImageVectorizationFilter } from "../../features/PopoverFilters/ImageVectorizationFilter";

const ImageGenerationResultPage: React.FC = () => {
    const { t } = useTranslation();
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [createdBy, setCreatedBy] = useState<string>("");
    const [noItems, setNoItems] = useState(15);
    const [isSeeAll, setIsSeeAll] = useState<boolean>(false);
    const [imageGenerationResults, setImageGenerationResults] = useState<Array<IImageGenerationDataModel> | null>();

    const fetchImages = useCallback(async (pageSize: number, createdBy: string, isSeeAll: boolean) => {
        setIsLoading(true);
        const result = await loadImageGenerationResults(pageSize, createdBy, isSeeAll);
        setImageGenerationResults(result);
        setIsLoading(false);
    }, []);

    useEffect(() => {
        fetchImages(noItems, createdBy, isSeeAll);
    }, []);
    return (
        <PageLayout>
            <PageHeader
                title="Image Generation"
                isDisplayBack={false}
                t={t}
                right={
                    <ImageVectorizationFilter
                        t={t}
                        noItems={noItems}
                        onApplyFilter={() => fetchImages(noItems, createdBy, isSeeAll)}
                        isLoading={isLoading}
                        setNoItems={setNoItems}
                        setCreatedBy={setCreatedBy}
                        createdBy={createdBy}
                        isSeeAll={isSeeAll}
                        setIsSeeAll={setIsSeeAll}
                    />
                }
            />
            <PageBody isLoading={isLoading} t={t}>
                <div className="p-3 mb-3">
                    {(!imageGenerationResults || Object.keys(imageGenerationResults).length === 0) ? (
                        <EmptyState message={t("Filter.resultsNotFound")} />
                    ) : (
                        <div className="d-flex flex-column gap-3 justify-content-center">
                            {imageGenerationResults.map(result => (
                                <ImageGenerationResultEntry
                                    key={result.sk}
                                    imageGenerationResult={result}
                                />

                            ))}
                        </div>
                    )}
                </div>
            </PageBody>
        </PageLayout>
    );
}

export default ImageGenerationResultPage;